// import React, { useRef } from 'react';
// import {
//   FaArrowLeft,
//   FaArrowRight,
// } from 'react-icons/fa';

// const certificateImages = [
//   '/images/cer1.jpg',
//   '/images/cer2.jpg',
//   '/images/cer3.jpg',
//   '/images/cer4.jpg',
//   '/images/cer5.jpg',
//   '/images/cer6.jpg',
//   '/images/cer7.jpg',
// ];

// const CompletionCertificates = () => {
//   const containerRef = useRef(null);

//   const scrollLeft = () => {
//     containerRef.current.scrollBy({ left: -500, behavior: 'smooth' });
//   };

//   const scrollRight = () => {
//     containerRef.current.scrollBy({ left: 500, behavior: 'smooth' });
//   };

//   return (
//     <section className="w-[90%] mx-auto py-12">
//       <h2 className="text-3xl font-bold text-gray-800 mb-6">Completion Certificates</h2>

//       <div className="relative">
//         {/* Left Arrow */}
//         <button
//                 onClick={scrollLeft}
//                   className="absolute left-0 sm:left-0 top-1/2 transform -translate-y-1/2 bg-gray-800/70 hover:bg-gray-800 text-white p-2 sm:p-3 rounded-full"
//                 >
//                   <FaArrowLeft />
//                 </button>
//         {/* <button
//           className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-amber-700 text-white w-10 h-10 rounded-full flex items-center justify-center shadow-md hover:bg-amber-800 transition"
//         >
//           &#8249;
//         </button> */}

//         {/* Carousel */}
//         <div
//           ref={containerRef}
//           className="flex gap-4 overflow-x-auto scroll-smooth no-scrollbar pr-4"
//         >
//           {certificateImages.map((src, index) => (
//             <div
//               key={index}
//               className="min-w-[300px] md:min-w-[350px] lg:min-w-[400px] h-40 sm:h-48 md:h-56 lg:h-64 border rounded shadow"
//             >
//               <img
//                 src={src}
//                 alt={`Certificate ${index + 1}`}
//                 className="w-full h-full "
//               />
//             </div>
//           ))}
//         </div>

//         {/* Right Arrow */}
//           <button
//                   onClick={scrollRight}
//                   className="absolute right-0 sm:right-0 top-1/2 transform -translate-y-1/2 bg-gray-800/70 hover:bg-gray-800 text-white p-2 sm:p-3 rounded-full"
//                 >
//                   <FaArrowRight />
//                 </button>
    
//         {/* <button
//           className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-amber-700 text-4xl px-3 p-0.5 text-white rounded-full flex items-center justify-center shadow-md hover:bg-amber-800 transition"
//         >
//           &#8250;
//         </button> */}
//       </div>
//     </section>
//   );
// };

// export default CompletionCertificates;


import React, { useRef, useEffect } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const certificateImages = [
  '/images/cer1.jpg',
  '/images/cer2.jpg',
  '/images/cer3.jpg',
  '/images/cer4.jpg',
  '/images/cer5.jpg',
  '/images/cer6.jpg',
  '/images/cer7.jpg',
];

const CompletionCertificates = () => {
  const containerRef = useRef(null);

  const scrollLeft = () => {
    containerRef.current.scrollBy({ left: -500, behavior: 'smooth' });
  };

  const scrollRight = () => {
    containerRef.current.scrollBy({ left: 500, behavior: 'smooth' });
  };

  // Auto-scroll effect
  useEffect(() => {
    const interval = setInterval(() => {
      scrollRight();
    }, 3000); // scroll every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <section className="w-[90%] mx-auto py-12">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">Completion Certificates</h2>

      <div className="relative">
        {/* Left Arrow */}
        <button
          onClick={scrollLeft}
          className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-800/70 hover:bg-gray-800 text-white p-2 sm:p-3 rounded-full z-10"
        >
          <FaArrowLeft />
        </button>

        {/* Carousel */}
        <div
          ref={containerRef}
          className="flex gap-4 overflow-x-auto scroll-smooth no-scrollbar pr-4"
        >
          {certificateImages.map((src, index) => (
            <div
              key={index}
              className="min-w-[300px] md:min-w-[350px] lg:min-w-[400px] h-78 sm:h-56 md:h-64 lg:h-72 border rounded shadow"
            >
              <img
                src={src}
                alt={`Certificate ${index + 1}`}
                className="w-full h-full rounded"
              />
            </div>
          ))}
        </div>

        {/* Right Arrow */}
        <button
          onClick={scrollRight}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-800/70 hover:bg-gray-800 text-white p-2 sm:p-3 rounded-full z-10"
        >
          <FaArrowRight />
        </button>
      </div>
    </section>
  );
};

export default CompletionCertificates;
